import React from "react";
import { Button } from "react-bootstrap";
import { Link } from "react-router-dom";

interface ErrorProps
{
    name: string;
}

class Error extends React.Component<ErrorProps>
{
    render()
    {
        return (
            <div className="text-center" id='error'>
                <br />
                <p className="error-text">Failed to retrieve {this.props.name}</p>
                {/* <Button type="button" className="btn btn-retry"><i className="fas fa-undo"></i> Retry</Button> */}
            </div>
        );
    }
}

export default Error;